// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const aron: PokeData = {
  "id": 304,
  "name": "aron",
  "height": 4,
  "weight": 600,
  "base_experience": 66,
  "types": [
    PokeType.STEEL,
    PokeType.ROCK
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "roar",
    "harden",
    "rock-slide",
    "protect",
    "mud-slap",
    "iron-tail",
    "metal-claw",
    "rock-tomb",
    "metal-sound",
    "iron-defense",
    "metal-burst",
    "iron-head",
    "autotomize",
    "heavy-slam"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "rock-slide",
    "protect",
    "mud-slap",
    "metal-claw",
    "rock-tomb",
    "metal-sound",
    "metal-burst",
    "stealth-rock",
    "rock-smash",
    "ancient-power",
    "rock-blast"
  ],
  "evolution_chain": {
    "id": 151,
    "item": null,
    "species": [
      {
        "name": "aron",
        "order": 330,
        "types": [
          PokeType.STEEL,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lairon",
        "order": 331,
        "types": [
          PokeType.STEEL,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 304,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "aggron",
        "order": 332,
        "types": [
          PokeType.STEEL,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 305,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 30,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
